import { Box, CircularProgress, Container, FormControlLabel, Switch, Typography, useMediaQuery, useTheme } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { TipoPrograma, tipos } from 'store/modules/EscolasTypes';
import { RootState } from 'store/reducer';
import { openModal } from 'store/modules/ModalActions';
import {
  getProgramaInfo,
  putPrograma,
  updateProgramaValue,
} from 'store/modules/EscolasActions';
import useProgramas from '../../hooks/useProgramas';
import './index.scss';
import { CustomRouteButton } from 'components/CustomRouteButton/CustomRouteButton';
import languageValues from 'utils/LanguageUtils';
import useCadastroSteps from 'pages/Escola/Cadastro/etapas/ProgramasEducacionais/hooks/useEscolaSteps';
import { Row } from 'components/Row';
import TabPrograma from '../TabPrograma';
import ModalInputAno from '../Modais/ModalInputAno';
import { HelpButton } from 'components/HelpButton';
import { useHistory, useParams } from 'react-router-dom';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { escolasRoute } from 'library/Routes';
import SnackbarUtils from '../../../../../../../utils/SnackbarUtils'
import ModalAviso from '../Modais/ModalAviso';
import { PROFILE_PUFV_ASSESSOR_PEDAGOGICO, PROFILE_PUFV_ASSESSOR_PEDAGOGICO_GESTOR } from 'library/Profiles';
import { getAssessorByCpf } from 'services/users';

export const TogglePrograma = () => {
  const { id } = useParams() as { id: string };
  const [loadingAssessor, setLoadingAssessor] = useState(false);
  const [localChecked, setLocalChecked] = useState<{ [key in TipoPrograma]?: boolean }>({});
  const { getNomePrograma } = useProgramas();
  const { handleBack } = useCadastroSteps();
  const auth = useSelector((state: RootState) => state.auth)
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'));

  const perfil = auth.userData?.perfil;
  const cpfAssessor = auth.userData?.id;
  const isAssessorPedagogico = perfil === PROFILE_PUFV_ASSESSOR_PEDAGOGICO.id;
  const isAssessorGestor = perfil === PROFILE_PUFV_ASSESSOR_PEDAGOGICO_GESTOR.id;
  const isAssessor = isAssessorPedagogico || isAssessorGestor;

  const programas = useSelector((state: RootState) => state.escolas.programas);
  const programaPermitidoAssessor = useSelector(
    (state: RootState) => state.escolas.assessorData.programasEducacionais);
  const history = useHistory();
  const dispatch = useDispatch();

  const tiposVisiveis = useMemo(() => {
    return isAssessor
      ? tipos.filter((tipo) => programaPermitidoAssessor.includes(Number(tipo)))
      : tipos;
  }, [isAssessor, programaPermitidoAssessor]);

  const openModalPrograma = (programaValue: TipoPrograma) => {
    dispatch(
      openModal(ModalInputAno, {
        title: `Implementação - ${getNomePrograma(programaValue)}`,
        confirmLabel: 'Prosseguir',
        cancelLabel: 'Cancelar',
        confirmThemeButton: 'button_PUFV',
        cancelThemeButton: 'button_PUFV',
        cancelCallback: () => {
          dispatch(updateProgramaValue(programaValue, { checked: false }));
          setLocalChecked((prev: { [key in TipoPrograma]?: boolean }
          ) => ({ ...prev, [programaValue]: false }));
        },
        idEscola: id,
        programaValue,
        modalKey: 'modal-programa',
      })
    );
  };

  const openModalDesativaPrograma = (tipoParam: TipoPrograma, checked: boolean) => {
    dispatch(openModal(ModalAviso, {
      modalKey: 'modal-desativar-programa',
      title: 'Aviso - Desativação',
      confirmLabel: 'Desativar',
      cancelLabel: 'Cancelar',
      content: (
        <>
          A desativação é feita sempre que o programa deixa de ser aplicado na escola selecionada. Você pode ativa-lo futuramente.
          <strong> Deseja desativar esse programa?</strong>
        </>
      ),
      confirmThemeButton: 'button_PUFV',
      cancelThemeButton: 'button_PUFV',
      tipoPrograma: TipoPrograma.FinancasNaMochila,
      ano: '',
      idEscola: id,
      cancelCallback: () => {
        setLocalChecked((prev) => ({ ...prev, [tipoParam]: !checked }));
        dispatch(updateProgramaValue(tipoParam, { checked: !checked }));
      },
      confirmCallback: () => {
        dispatch(
          putPrograma(
            Number(id),
            Number(tipoParam),
            checked,
            () => dispatch(getProgramaInfo(id, tipoParam)),
            (error) => {
              SnackbarUtils.enqueueSnackbar({
                message: error,
                options: { variant: 'error' },
              });
              setLocalChecked((prev) => ({ ...prev, [tipoParam]: !checked }));
              dispatch(updateProgramaValue(tipoParam, { checked: !checked }));
            }))
      },
    }))
  }

  useEffect(() => {
    setLocalChecked({});
    tipos.forEach((tipo) => {
      dispatch(updateProgramaValue(tipo, {
        checked: false,
        anoImplementacao: undefined,
      }));
    });
    tipos.forEach((tipo) => {
      dispatch(getProgramaInfo(id, tipo));
    });
  }, [id, dispatch]);

  const handleToggleChange = useCallback((tipo: TipoPrograma, isChecked: boolean) => {
    setLocalChecked((prev) => ({ ...prev, [tipo]: isChecked }));
    dispatch(updateProgramaValue(tipo, { checked: isChecked }));

    const programa = programas[tipo];
    const anoVazio = !programa?.anoImplementacao || programa.anoImplementacao.trim() === '';
    const objetoVazio = !programa || Object.keys(programa).length === 0;

    if (isChecked && (anoVazio || objetoVazio)) {
      openModalPrograma(tipo);
    } else if (!isChecked) {
      openModalDesativaPrograma(tipo, isChecked);
    } else {
      dispatch(
        putPrograma(
          Number(id),
          Number(tipo),
          isChecked,
          () => dispatch(getProgramaInfo(id, tipo)),
          (error) => {
            SnackbarUtils.enqueueSnackbar({
              message: error,
              options: { variant: 'error' },
            });
            setLocalChecked((prev) => ({ ...prev, [tipo]: !isChecked }));
            dispatch(updateProgramaValue(tipo, { checked: !isChecked }));
          }
        )
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, id, programas]);

  useEffect(() => {
    if ((isAssessorPedagogico || isAssessorGestor) && cpfAssessor) {
      setLoadingAssessor(true);
      dispatch(getAssessorByCpf(cpfAssessor) as any)
        .then(() => setLoadingAssessor(false))
        .catch(() => setLoadingAssessor(false));
    } else {
      localStorage.removeItem('assessorPrograma');
    }
  }, [auth.userData.id, auth.userData.perfil, cpfAssessor, dispatch, isAssessorGestor, isAssessorPedagogico]);

  const tabProgramasComDados = useMemo(() => {
    return tiposVisiveis.filter((tipo) => programas[tipo]?.anoImplementacao);
  }, [tiposVisiveis, programas]);

  return (
    <Container maxWidth="lg" className="toggle_container-layout">
      <Box className="toggle_container-title">
        <Typography className="toggle_label--big">Dados dos programas educacionais</Typography>
        <Typography className="toggle_label--small">
          Preencha os dados sobre os programas educacionais que sua instituição possuí:
        </Typography>
      </Box>

      {(loadingAssessor) ? (
        <CircularProgress />
      ) : (
        <Box className="toggle_container-toggle">
          {tiposVisiveis.map((tipo) => {
            const reducerChecked = programas[tipo]?.checked || false;
            const checked = localChecked[tipo] ?? reducerChecked;
            return (
              <FormControlLabel
                key={tipo}
                className="toggle_switch-label"
                label={
                  <Box display="flex" flexDirection="column" alignItems="flex-start">
                    <Box display="flex" alignItems="center">
                      <Typography
                        style={{
                          textAlign: 'left',
                          maxWidth: isMobile ? '12.5rem' : '',
                          whiteSpace: isMobile ? 'nowrap' : 'normal',
                          overflow: isMobile ? 'hidden' : 'visible',
                          textOverflow: isMobile ? 'ellipsis' : 'unset',
                        }}
                      >
                        {getNomePrograma(tipo)}
                      </Typography>

                      <HelpButton
                        style={{ marginLeft: '0.313rem' }}
                        text="É possível habilitar e desabilitar os programas educacionais em sua escola."
                      />
                    </Box>
                    {programas[tipo]?.anoImplementacao && (
                      <Typography variant="caption" color="textSecondary" style={{ marginTop: 2 }}>
                        Programa implantado em {programas[tipo].anoImplementacao}
                      </Typography>
                    )}
                  </Box>
                }
                control={
                  <Switch
                    id={`toggle-${tipo}`}
                    color="primary"
                    className="toggle_switch"
                    checked={checked}
                    onChange={(e) => handleToggleChange(tipo, e.target.checked)}
                  />
                }
              />
            );
          })}
        </Box>
      )}

      <TabPrograma programasVisiveis={tabProgramasComDados} />

      <Row className="buttonSteps">
        <CustomRouteButton
          backButtonProps={{
            children: languageValues.pages.escolas.buttons.anterior,
            onClick: handleBack,
          }}
          isLabelRequiredVisible
          saveButtonProps={{
            children: 'Finalizar',
            onClick: () => {
              history.push(escolasRoute.path)
            },
          }}
        />
      </Row>
    </Container>
  );
};

